import React, { FunctionComponent } from 'react';

interface TickIconProps {
  className: string;
}

// B2C_044 - Donate to yourself
// Remove this when removing this experiment
export const TickIconFilled: FunctionComponent<TickIconProps> = ({
  className,
}) => {
  return (
    <svg
      width="60px"
      height="60px"
      viewBox="0 0 60 60"
      version="1.1"
      className={className}
    >
      <g
        id="FR---Mobile-Existing-user---Logged-in-B-version---One-Click-donation"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="FR---1st-Time---THANKS-FOR-DONATION--TIMEBASED-Copy-22"
          transform="translate(-37.000000, -67.000000)"
        >
          <g id="tick" transform="translate(37.000000, 67.000000)">
            <circle
              id="Oval-109"
              fill="#15CC5E"
              cx="30"
              cy="30"
              r="30"
            ></circle>

            <path
              d="M23.0317302,42.6324674 L14.2849095,33.9457544 C13.9050681,33.5684153 13.9050681,32.9568501 14.2846819,32.5795109 L16.3477509,30.5295805 C16.7273647,30.1522414 17.3432129,30.1520153 17.7230543,30.5293544 L23.370606,36.1383457 C23.563144,36.3296153 23.8753922,36.3298414 24.0681578,36.1383457 L43.0588612,17.2826935 C43.4389302,16.9055805 44.0547785,16.9058066 44.4343922,17.2831457 L46.4967785,19.3333022 C46.8763922,19.7106414 46.8761647,20.3224327 46.4963233,20.6995457 L24.406806,42.6324674 C24.0269647,43.0095805 23.4115716,43.0095805 23.0317302,42.6324674"
              id="Fill-1"
              fill="#FFFFFF"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
